import { BuilderContent } from '@builder.io/react';
import classNames from 'classnames';
import Image from 'next/image';
import { FC, useMemo } from 'react';
import Marquee from 'react-fast-marquee';

import { BusinessIndustries, BusinessIndustryTrustedBrand } from '../../types/BusinessIndustries';
import styles from './business-hub-trusted-brand.module.scss';

export interface BusinessHubTrustedBrandProps {
    title?: string;
    trustedBrands?: BusinessIndustries['trustedBrands'];
    textColor?: string;
    background?: string;
    roundedBottom?: boolean;
    isCarousel?: boolean;
    className?: string;
    industryCommon?: {
        value: BuilderContent;
    };
}

const BusinessHubTrustedBrand: FC<BusinessHubTrustedBrandProps> = (props) => {
    const { title, className, trustedBrands = [], industryCommon, textColor, background, roundedBottom, isCarousel } = props;

    const brands = useMemo(() => {
        if (trustedBrands?.length > 0) return trustedBrands;

        const commonTrustedBrands = (industryCommon?.value?.data as any)?.trustedBrands as BusinessIndustries['trustedBrands'];
        if (commonTrustedBrands && commonTrustedBrands.length > 0) return commonTrustedBrands;

        return [];
    }, [trustedBrands, industryCommon]);

    const _renderItem = (item: BusinessIndustryTrustedBrand) => {
        return (
            <Image
                src={item.logo}
                alt=""
                style={{ objectFit: 'contain', objectPosition: 'center center' }}
                fill={true}
                sizes="(max-width: 638px) 98vw,  (max-width: 998px) 43vw, 46vw"
                loading={'eager'}
                loader={({ src, width, quality }) => {
                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                }}
                className={styles.image}
            />
        );
    };

    return (
        <div className={classNames(styles.container, className)} style={{ '--data-text-color': textColor, '--data-background': background } as any}>
            <div className={classNames(styles.background, { [styles.roundedBottom]: roundedBottom })} />
            <div className={styles.wrapperContent}>
                {title ? <div className={styles.title}>{title}</div> : null}
                <div className={classNames(styles.wrapperLogo, { [styles.flexWrap]: !isCarousel, [styles.fullwidth]: isCarousel })}>
                    {isCarousel ? (
                        <Marquee loop={0} autoFill>
                            {brands.map((item, index) => (
                                <div
                                    key={`${item.logo}-${index}`}
                                    className={`${styles.logo} ${styles.autoMargin}`}
                                    style={{ aspectRatio: `${item.ratio ? 1 / item.ratio : ''}`, maxWidth: item.maxWidth, height: item.maxHeight }}
                                >
                                    {_renderItem(item)}
                                </div>
                            ))}
                        </Marquee>
                    ) : (
                        brands.map((item) => (
                            <div
                                key={item.logo}
                                className={styles.logo}
                                style={{ aspectRatio: `${item.ratio ? 1 / item.ratio : ''}`, maxWidth: item.maxWidth, height: item.maxHeight }}
                            >
                                {_renderItem(item)}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default BusinessHubTrustedBrand;
